module.exports = __webpack_public_path__ + "static/media/screenshot_history_3_ru.6eb878c0.png";